import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getAvailableInfrastructureTypes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_AVAILABLE_INFRASTRUCTURE_TYPES,
		options
	)
}

function _getInfrastructureType(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_INFRASTRUCTURE_TYPE,
		options
	)
}

function _getInfrastructureTypesPreview(options={}) {
	return _apiRequestWrap(ModulesMap.INFRASTRUCTURE_TYPES, ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_INFRASTRUCTURE_TYPES_PREVIEW, options)
}

function _createInfrastructureTypes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].CREATE_INFRASTRUCTURE_TYPES,
		options
	)
}

function _patchInfrastructureTypes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].PATCH_INFRASTRUCTURE_TYPES,
		options
	)
}

function _putInfrastructureTypes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].PUT_INFRASTRUCTURE_TYPES,
		options
	)
}

function _deleteInfrastructureTypes(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INFRASTRUCTURE_TYPES,
		ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].DELETE_INFRASTRUCTURE_TYPES,
		options
	)
}

export default {
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_AVAILABLE_INFRASTRUCTURE_TYPES]: _getAvailableInfrastructureTypes,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_INFRASTRUCTURE_TYPES_PREVIEW]: _getInfrastructureTypesPreview,

	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].GET_INFRASTRUCTURE_TYPE]: _getInfrastructureType,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].CREATE_INFRASTRUCTURE_TYPES]: _createInfrastructureTypes,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].PATCH_INFRASTRUCTURE_TYPES]: _patchInfrastructureTypes,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].PUT_INFRASTRUCTURE_TYPES]: _putInfrastructureTypes,
	[ModulesConfigMap[ModulesMap.INFRASTRUCTURE_TYPES].DELETE_INFRASTRUCTURE_TYPES]: _deleteInfrastructureTypes,
}